import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { queryOnlineSiteInfoList } from '@/api/api';
export default {
  name: 'SelectSiteListModal',
  components: {},
  data: function data() {
    return {
      title: '选择站点',
      queryParam: {},
      columns: [{
        title: '编号',
        align: 'center',
        dataIndex: 'mn',
        fixed: 'left',
        width: 200
      }, {
        title: '名称',
        align: 'center',
        dataIndex: 'name'
      }, // {
      //   title: '站点类型',
      //   align: 'center',
      //   dataIndex: 'category_dictText',
      // },
      // {
      //   title: '运营中心',
      //   align: 'center',
      //   dataIndex: 'departName',
      // },
      {
        title: '状态',
        align: 'center',
        dataIndex: 'status_dictText'
      }],
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false
    };
  },
  created: function created() {},
  methods: {
    loadData: function loadData(arg) {
      var _this = this;

      //
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      queryOnlineSiteInfoList(params).then(function (res) {
        if (res.success) {
          debugger;
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    add: function add(selectSite, siteIds) {
      this.visible = true;
      this.edit(selectSite, siteIds);
    },
    edit: function edit(selectSite, siteIds) {
      this.loadData();

      if (!siteIds) {
        this.selectedRowKeys = [];
      } else {
        this.selectedRowKeys[0] = siteIds;
      }

      if (!selectSite) {
        this.selectionRows = [];
      } else {
        this.selectionRows = selectSite;
      }
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = 'id,';

      for (var a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex;
      }

      return str;
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    searchReset: function searchReset() {
      var that = this;
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = '';
      });
      that.loadData(1);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleCancel: function handleCancel() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    handleOk: function handleOk() {
      this.$emit('choseArchive', this.selectionRows);
      this.handleCancel();
    },
    searchByquery: function searchByquery() {
      this.loadData(1);
    },
    handleToggleSearch: function handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    }
  }
};